<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link :to="{ path: BACKEND_URL + '/users/edit/' + user.id, props: { id: user.id } }" v-if="$can('user-edit')">
        <action-button type="edit" />
      </router-link>

      <router-link :to="{ path: BACKEND_URL + '/users/roles/' + user.id, props: { id: user.id } }" v-if="$can('user-edit')">
        <action-button type="role" />
      </router-link>

      <action-button type="delete" @click="del(user.id)" v-if="$can('user-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  :label="$t('users.first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    v-model="person.middle_name"
                                    :label="$t('users.middle_name')"
                                    readonly
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="person.last_name" :label="$t('users.last_name')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="person.mobile" :label="$t('users.mobile')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field v-model="user.email" :label="$t('users.email')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "UserForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      user: {},
      person: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "user/" + this.id)
      .then((res) => {
        this.user = res.data.data
        this.person = res.data.data.person

        this.page_title = this.$t("users.view_user", { name: this.person.first_name + " " + this.person.last_name })
      })
      .catch((err) => console.log(err))
  },
  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "user/" + id)
            .then(() => {
              vm.$router.push(vm.BACKEND_URL + "/users")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
